import ApprovedTimeOffRequests from './ApprovedTimeOffRequests';

export default ApprovedTimeOffRequests;
